import React, { useState } from "react";

import "./password_authentication.css";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LockResetIcon from "@mui/icons-material/LockReset";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import logo from "../../images/PPKM_Head.png";
import getEventController from "../Member/Controller/getEvent_controller";

const PasswordAuthentication = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, userID, companyName, memberId } = location.state; // Access passed data
  console.log(email);
  console.log(userID);
  console.log(companyName);
  console.log(memberId);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMemberLogin = async (e) => {
    e.preventDefault();
    setError(null); // Reset error

    console.log(userID);
    console.log(password);

    // Call the authentication function
    const data = await getEventController.authenticateUser(userID, password);

    if (data) {
      // If successful, navigate to the next page, e.g., OTP page or dashboard
      navigate("/dashboard");
      // console.log(data);
    } else {
      setError("Wrong password. Please try again.");
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError(null); // Reset error

    console.log(email);

    // Call the authentication function
    const data = await getEventController.SendOTP(email);

    if (data) {
      // If successful, navigate to the next page, e.g., OTP page or dashboard
      navigate("/otp", {
        state: { email, userID, companyName, memberId, sent_otp: data },
      });
      // navigate("/membership_selection", { state: { email } });

      // console.log(data);
    } else {
      setError("Invalid email. Please try again.");
    }
  };

  return (
    <div className="password-authentication-page">
      <div className="d-flex password-authentication-container">
        <div className="password-authentication-wrapper">
          <div className="login-title">
            <img className="pa-web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="pa-title_para">PASSWORD AUTHENTICATION</p>
          <p className="re-span">
            You've selected to login.
            <br /> Kindly enter the correct password to login.
          </p>
          <div className="mt-2">
            <label className="form-label pa-form-label">Login As</label>
            <div className="account-info-block">
              <span className="account-info-lbl">{companyName}</span>
              <span className="account-info-lbl2">
                Membership No.: {memberId}
              </span>
            </div>
          </div>
          <form
            className="password-authentication-form"
            onSubmit={handleMemberLogin}
          >
            <div className="password-row">
              <label className="form-label">Password</label>
              <div className="pa-row">
                {/* password */}
                <LockIcon className="login-form-logo" />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <IconButton
                  onClick={togglePasswordVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </div>
            </div>
            <div>
              <Button className="reset-button" type="submit">
                Login
              </Button>
            </div>
            <div>
              <Button
                className="reset-button"
                onClick={() =>
                  navigate("/membership_selection", { state: { email } })
                }
              >
                Back
              </Button>
            </div>
            {/* forgot password */}
            <div>
              <div className="forgot-password">
                <label>Forgot your password?</label>
              </div>
              <div className="pass forgot-password">
                <a onClick={handleResetPassword}>Forgot password</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordAuthentication;
